import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import CustomTable from "../../../Components/common/Table/CustomTable";
import ListPopup from "../../../Components/PagesComponents/Dashboard/ListPopup/ListPopup";
import CustomSelect from "../../../Components/common/CustomSelect/CustomSelect";
import ActionButton from "../../../Components/common/ActionButton/ActionButton";
import FileIcon from "../../../Components/Icon-SVG/FileIcon";
import {
  DetailEmpty,
  DetailField,
  DetailGrid,
  DetailItem,
  DetailNote,
  DetailPanel,
} from "../../../Components/common/DetailPanel/DetailPanel";

import { networkDetectionsHeader } from "../../../utils/constants/tableHeaders";

import {
  RequestDistinctHosts,
  RequestNetworkDetections,
} from "../../../store/actions/networkDefenderActions";

import "./styles.scss";

//GET FILE ID IN URL
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const Details = ({ row, history }) => {
  const original = row?.original;
  const snort = original?.SnortLog;
  const groupID = original?.groupID;
  const detection = original?.log?.detection;

  const sboxDetailsClickHandler = () => {
    if (original?.request) {
      history.push({ pathname: "/dashboard", state: { fromRemoteConnection: true } });
    } else if (groupID && groupID !== "-") {
      history.push(`/network-detections?data=${groupID}&table=network-detections`);
    }
  };

  if (snort) {
    return (
      <DetailPanel>
        <DetailGrid columns={3}>
          <DetailField label="Rule">{snort?.log?.description}</DetailField>
          <DetailField label="Importance">{snort?.log?.importance}</DetailField>
          <DetailField label="Signature ID" mono>
            {snort?.log?.sigId}
          </DetailField>
        </DetailGrid>
      </DetailPanel>
    );
  } else if (groupID) {
    return (
      <DetailPanel>
        <DetailItem
          actions={
            <ActionButton
              icon={<FileIcon width={13} height={13} color="currentColor" />}
              onClick={sboxDetailsClickHandler}
              disabled={groupID === "-"}
            >
              {detection === "SboxSubmitLog" && original?.request ? "Running" : "See Report"}
            </ActionButton>
          }
        >
          <DetailGrid columns={3}>
            <DetailField label="File name">{original?.file_name}</DetailField>
            <DetailField label="SHA256" mono>
              {original?.hash}
            </DetailField>
            <DetailField label="Submitted at">
              {original?.time_stamp
                ? `${original.time_stamp.split(" ")[0]} (${original.time_stamp.split(" ")[1]})`
                : null}
            </DetailField>
          </DetailGrid>
        </DetailItem>
      </DetailPanel>
    );
  } else if (original?.log?.detection === "UrlBlock") {
    return (
      <DetailPanel>
        <DetailNote tone="danger" title="URL block">
          The URL is on the known malicious list, so the request was blocked.
        </DetailNote>
      </DetailPanel>
    );
  } else {
    return (
      <DetailPanel>
        <DetailEmpty>No details found.</DetailEmpty>
      </DetailPanel>
    );
  }
};

const NetworkDetections = () => {
  const [selectedHost, setSelectedHost] = useState(null);
  const [selectedTimeFilter, setSelectedTimeFilter] = useState(null);
  const [listPopupActive, setListPopupActive] = useState(false);

  const dispatch = useDispatch();

  const distinctHosts = useSelector((state) => state.networkDefender.distinctHosts);
  const distinctHostsLoading = useSelector((state) => state.networkDefender.distinctHostsLoading);
  const networkDetections = useSelector((state) => state.networkDefender.networkDetections);

  let query = useQuery();

  useEffect(() => {
    dispatch(RequestDistinctHosts());

    return () => {
      localStorage.setItem("networkDetectionsToggle", JSON.stringify({ ids: [] }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (selectedHost?.id) {
      dispatch(RequestNetworkDetections({ host: selectedHost.id, timeFilter: selectedTimeFilter }));
    }
  }, [selectedHost, selectedTimeFilter, dispatch]);

  useEffect(() => {
    if (query.get("data") !== null) {
      setListPopupActive(true);
    } else {
      setListPopupActive(false);
    }
  }, [query]);

  return (
    <div className="network-detections">
      <div className="network-detections__header">
        <h1>Network Detections</h1>
        <p>Below list is displaying network detections of selected host:</p>
        <div className="network-detections__header__select">
          <p>Select host: </p>
          <CustomSelect
            id="networkDetections"
            data={distinctHosts.length ? distinctHosts : []}
            select={selectedHost}
            setSelected={setSelectedHost}
            width={200}
            disabled={distinctHosts.length === 0}
            placeholder={distinctHostsLoading ? "Fetching data..." : "No data."}
          />
        </div>
      </div>
      <div className="network-detections__table border">
        <CustomTable
          exportFile={true}
          dataNetworkDetections={networkDetections}
          selectedHost={selectedHost?.id}
          tableName="networkDetections"
          column={networkDetectionsHeader}
          leftAction={true}
          paginationButtons={true}
          className=""
          customPageSize={10}
          renderRowSubComponent={Details}
          minHeight="585px"
          minBottom="5px"
          defaultPosition="relative"
          filterByTime={true}
          selectedTimeFilter={selectedTimeFilter}
          setSelectedTimeFilter={setSelectedTimeFilter}
          defaultFilterIndex={2}
        />
      </div>
      <ListPopup
        onClickOk={() => setListPopupActive(false)}
        show={listPopupActive}
        groupID={query.get("data")}
        tableType={query.get("table")}
        tableType2="network-detections"
      />
    </div>
  );
};

export default NetworkDetections;
